(function () {
  function publish(name, payload) {
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish(name, payload);
    }
  }

  // --- CTA click tracking: any '.btn' link/button clicked on the homepage ---
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.btn, button.btn');
    if (!link) return;

    var text = (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120);
    var href = link.getAttribute('href') || '';
    var sectionEl = link.closest('[id^="shopify-section-"]');
    var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';

    publish('homepage_cta_click', {
      text: text,
      href: href,
      sectionId: sectionId
    });
  }, true);

  // --- Scroll depth tracking: fires once per milestone per pageview ---
  var milestones = [25, 50, 75, 90];
  var fired = {};

  function checkScroll() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return;

    var pct = Math.round((scrollTop / docHeight) * 100);
    milestones.forEach(function (m) {
      if (pct >= m && !fired[m]) {
        fired[m] = true;
        publish('homepage_scroll_depth', { percent: m });
      }
    });
  }

  var ticking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          checkScroll();
          ticking = false;
        });
        ticking = true;
      }
    },
    { passive: true }
  );
})();
